import { render, staticRenderFns } from "./StudentRelationsRosterProfileList.vue?vue&type=template&id=55468df6&scoped=true&"
import script from "./StudentRelationsRosterProfileList.vue?vue&type=script&lang=js&"
export * from "./StudentRelationsRosterProfileList.vue?vue&type=script&lang=js&"
import style0 from "./StudentRelationsRosterProfileList.vue?vue&type=style&index=0&id=55468df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55468df6",
  null
  
)

export default component.exports